import React, { useState, useEffect, useContext } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { Row, Col } from "reactstrap";
import Switch from "react-switch";
import { useDispatch, useSelector } from "react-redux";
import {
  API,
  EMPTY_DATA,
  AccGroupMasterList,
  defaultPageSize,
} from "../../../config/constants";
import NoContentFound from "../../common/NoContentFound";
import PopupMsgWrapper from "../../common/PopupMsgWrapper";
import { PaginationWrapper } from "../../common/commonPagination";
import LoaderCustom from "../../common/LoaderCustom";
import { reactLocalStorage } from "reactjs-localstorage";
import _ from "lodash";
import ReactExport from "react-export-excel";
import {
  apiErrors,
  handleDepartmentHeader,
  notify,
  searchNocontentFilter,
  setLoremIpsum,
  userDetails,
} from "../../../helper";
import { resetStatePagination } from "../../common/Pagination/paginationAction";
import { setSelectedRowForPagination } from "../../simulation/actions/Simulation";
import { ANNUAL_KYS_UPDATES_EXCEL } from "../../../config/masterData";
import axiosHelper from "../../../axiosHelper";
import { ApplyAnnualKYSUpdates } from ".";
import DayTime from "../../common/DayTimeWrapper";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const gridOptions = {};

const MasterUpdateRequests = (props) => {
  const permissionAnnualKYSUpdates = useContext(ApplyAnnualKYSUpdates);

  const dispatch = useDispatch();
  const [isModalRejectOpen, setIsModalRejectOpen] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [loader, setloader] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [accountGroupOnAction, setAccountGroupOnAction] = useState(null);
  const [annualKYSUpdateRequestList, setAnnualKYSUpdateRequestList] = useState([]);

  const [state, setState] = useState({
    isEditFlag: false,
    isOpenVendor: false,
    shown: false,
    ID: "",
    tableData: [],
    city: [],
    country: [],
    state: [],
    showPopup: false,
    deletedId: "",
    cellData: {},
    cellValue: "",
    showPopupToggle: false,
    isViewMode: false,
    isLoader: false,
    selectedRowData: false,
    noData: false,
    dataCount: 0,
    type: "",
    render: false,
    showExtraData: false,
  });

  const getAnnualKYSUpdateRequests = () => {
    setloader(true);
    axiosHelper.get(`${API.getAnnualKYSUpdateRequestList}`)
      .then((response) => {
        // 
        if (response.data?.IsSuccessful) {
          setAnnualKYSUpdateRequestList(response.data?.Data);
          setloader(false);
        }
      })
      .catch((error) => {
        apiErrors(error);
        throw error; // Re-throw the error to the caller
      });
  };

  /**
   * @method onFloatingFilterChanged
   * @description Filter data when user type in searching input
   */
  const onFloatingFilterChanged = (value) => {
    setTimeout(() => {
      if (annualKYSUpdateRequestList.length !== 0) {
        setState((prevState) => ({
          ...prevState,
          noData: searchNocontentFilter(value, prevState.noData),
        }));
      }
    }, 500);
  };

  useEffect(() => {
    getAnnualKYSUpdateRequests();
  }, []);

  useEffect(() => {
    reactLocalStorage.setObject("selectedRow", {});
    if (!props.stopApiCallOnCancel) {
      return () => {
        dispatch(setSelectedRowForPagination([]));
        dispatch(resetStatePagination());

        reactLocalStorage.setObject("selectedRow", {});
      };
    }
  }, []);

  const onRowSelect = () => {
    const selectedRows = state.gridApi?.getSelectedRows();
    setState((prevState) => ({
      ...prevState,
      selectedRowData: selectedRows,
      dataCount: selectedRows.length,
    }));
  };
  const onBtExport = () => {
    let tempArr = state.gridApi && state.gridApi.getSelectedRows();
    tempArr =
      tempArr && tempArr.length > 0
        ? tempArr
        : annualKYSUpdateRequestList
          ? annualKYSUpdateRequestList
          : [];
    return returnExcelColumn(ANNUAL_KYS_UPDATES_EXCEL, tempArr);
  };
  const resetState = () => {
    const searchBox = document.getElementById("filter-text-box");
    if (searchBox) {
      searchBox.value = "";
    }
    state.gridApi.setQuickFilter(null);
    state.gridApi.deselectAll();
    state.gridApi.setFilterModel(null);
    state.gridColumnApi.resetColumnState();
    setState((prevState) => ({ ...prevState, noData: false }));
  };
  const returnExcelColumn = (data = [], TempData) => {
    return (
      <ExcelSheet data={TempData} name={AccGroupMasterList}>
        {data &&
          data.map((ele, index) => (
            <ExcelColumn
              key={index}
              label={
                ele.label === "Company Name"
                  ? `${handleDepartmentHeader()} Name`
                  : ele.label
              }
              value={ele.value}
              style={ele.style}
            />
          ))}
      </ExcelSheet>
    );
  };
  const isFirstColumn = (params) => {
    var displayedColumns = params.columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  };
  const defaultColDef = {
    resizable: true,
    filter: true,
    sortable: false,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: isFirstColumn,
  };
  const onGridReady = (params) => {
    window.screen.width >= 1600 && params.api.sizeColumnsToFit();
    setState((prevState) => ({
      ...prevState,
      gridApi: params.api,
      gridColumnApi: params.columnApi,
    }));
    params.api.paginationGoToPage(0);
  };
  const onPageSizeChanged = (newPageSize) => {
    state.gridApi.paginationSetPageSize(Number(newPageSize));
  };

  const buttonFormatter = (props) => {
    let empId = userDetails();
    const intiaterCheckFlag = props?.data?.VNFRequester == empId?.EmployeeId;

    props.api.sizeColumnsToFit();
    const handleView = () => {
      
      // Extract necessary IDs
      // const requestId = props.data?.VendorRequirementRegistrationId;
      // // Construct the base URL
      // let url = `view-supplier-need-form?VendorRequirementRegistrationId=${requestId}`;
      // // Navigate to the constructed URL
      // history.push(url);
    };

    return (
      <div>
        {permissionAnnualKYSUpdates?.View && (
          <button
            title="View"
            className="View mr-2"
            type="button"
            onClick={handleView}
          >
            {/* View */}
          </button>
        )}
      </div>
    );
  };
  const statusButtonFormatter = (cell, row, enumObject, rowIndex) => {
    return (
      <>
        <label htmlFor="normal-switch" className="normal-switch">
          <Switch
            // onChange={() => handleChange(cell, row, enumObject, rowIndex)}
            checked={cell}
            background="#ff6600"
            onColor="#4DC771"
            onHandleColor="#ffffff"
            id="normal-switch"
            height={24}
          />
        </label>
      </>
    );
  };

  const effectiveDateFormatter = (props) => {
    const cellValue = props?.valueFormatted
      ? props.valueFormatted
      : props?.value;
    return cellValue != null ? DayTime(cellValue).format("DD/MM/YYYY") : "";
  };

  const frameworkComponents = {
    totalValueRenderer: buttonFormatter,
    statusButtonFormatter: statusButtonFormatter,
    effectiveDateRenderer: effectiveDateFormatter,
    // hyphenFormatter: hyphenFormatter,
    // customNoRowsOverlay: NoContentFound,
    // checkBoxRenderer: checkBoxRenderer,
    // valuesFloatingFilter: SingleDropdownFloationFilter,
  };

  const deleteAccountGroupMaster = (groupMaster) => {
    setloader(true);
    axiosHelper
      .delete(`${API.removeAccountGroupMaster}?Id=${groupMaster?.Id}`)
      .then((response) => {
        getAnnualKYSUpdateRequests();
        setloader(false);
        if (response?.data?.IsSuccessful) {
          notify.success(response?.data?.Data?.Message);
        }
      })
      .catch((error) => {
        setloader(false);
        if (!error?.response?.data?.IsSuccessful) {
          notify.error(error?.response?.data?.ErrorMessage);
        }
      });
    // http://10.10.1.100:8081/api/v1/AccountGroupMaster/RemoveAccountGroupMaster?Id=1
    setloader(true); // Set loader to indicate deletion process
  };

  const onPopupConfirm = () => {
    setShowDeletePopup(false);
    deleteAccountGroupMaster(accountGroupOnAction);
  };
  const closePopUp = () => {
    setShowDeletePopup(false);
  };

  const onRejectConfirm = () => {
    setIsModalRejectOpen(false);
  };

  return (
    <>
      {loader && <LoaderCustom customClass="simulation-Loader" />}
      {showDeletePopup && (
        <PopupMsgWrapper
          isOpen={showDeletePopup}
          closePopUp={closePopUp}
          confirmPopup={onPopupConfirm}
          message={`Are you sure you want to delete this item?`}
        />
      )}

      {isModalRejectOpen && (
        <PopupMsgWrapper
          isOpen={isModalRejectOpen}
          closePopUp={closePopUp}
          confirmPopup={onRejectConfirm}
          // buttonLoader={submitionLoading}
          message={`Are you sure you want to reject this application?`}
        />
      )}
      <>
        <Row className="ag-grid-react without-filter-grid">
          <Col>
            <div>
              <div
                className={`ag-theme-material ${loader && "max-loader-height"}`}
              >
                <Row className={`filter-row-large`}>
                  <Col md="12" className="mb-3 d-flex justify-content-end">
                    <div className="d-flex justify-content-end bd-highlight w100">
                      {permissionAnnualKYSUpdates?.Download && (
                        <ExcelFile
                          filename={AccGroupMasterList}
                          fileExtension={".xls"}
                          element={
                            <button
                              title={`Download ${state.dataCount === 0
                                ? "All"
                                : "(" + state.dataCount + ")"
                                }`}
                              type="button"
                              className={"user-btn mr5 Tour_List_Download"}
                            >
                              <div className="download mr-1"></div>
                              {`${state.dataCount === 0
                                ? "All"
                                : "(" + state.dataCount + ")"
                                }`}
                            </button>
                          }
                        >
                          {onBtExport()}
                        </ExcelFile>
                      )}
                      <button type="button" className="user-btn Tour_List_Reset" title="Reset Grid" onClick={() => resetState()}>
                        <div className="refresh mr-0"></div>
                      </button>
                    </div>
                  </Col>
                </Row>
                <div
                  className={`ag-grid-wrapper height-width-wrapper ${(annualKYSUpdateRequestList &&
                    annualKYSUpdateRequestList?.length <= 0) ||
                    state.noData
                    ? "overlay-contain"
                    : ""
                    }`}
                >
                  <div
                    className={`ag-theme-material ${state.isLoader && "max-loader-height"
                      }`}
                  >
                    {annualKYSUpdateRequestList?.length <= 0 && (
                      <NoContentFound
                        title={EMPTY_DATA}
                        customClassName="no-content-found"
                      />
                    )}
                    {state.isLoader ? (
                      <LoaderCustom customClass="loader-center" />
                    ) : (
                      <AgGridReact
                        defaultColDef={defaultColDef}
                        floatingFilter={true}
                        domLayout="autoHeight"
                        // columnDefs={c}
                        rowData={
                          state.showExtraData && annualKYSUpdateRequestList
                            ? [
                              ...setLoremIpsum(annualKYSUpdateRequestList[0]),
                              ...annualKYSUpdateRequestList,
                            ]
                            : annualKYSUpdateRequestList
                        }
                        pagination={true}
                        paginationPageSize={defaultPageSize}
                        onGridReady={onGridReady}
                        gridOptions={gridOptions}
                        noRowsOverlayComponent={"customNoRowsOverlay"}
                        noRowsOverlayComponentParams={{
                          title: EMPTY_DATA,
                          imagClass: "imagClass",
                        }}
                        rowSelection={"multiple"}
                        suppressRowClickSelection={true}
                        onSelectionChanged={onRowSelect}
                        onFilterModified={onFloatingFilterChanged}
                        frameworkComponents={frameworkComponents}
                      >
                        <AgGridColumn
                          cellClass="has-checkbox"
                          field="TicketNo"
                          sortable={true}
                          floatingFilter={true}
                          unSortIcon={true}
                          filter={true}
                          comparator={(
                            valueA,
                            valueB,
                            nodeA,
                            nodeB,
                            isInverted
                          ) =>
                            valueA
                              .toLowerCase()
                              .localeCompare(valueB.toLowerCase())
                          }
                          headerName="Ticket No"
                        ></AgGridColumn>
                        <AgGridColumn
                          field="VendorCode"
                          floatingFilter={true}
                          headerName="Supplier Code"
                        ></AgGridColumn>
                        <AgGridColumn
                          field="VendorName"
                          floatingFilter={true}
                          headerName="Supplier Name"
                        ></AgGridColumn>
                        <AgGridColumn
                          field="RequestType"
                          floatingFilter={true}
                          headerName="Request Type"
                        ></AgGridColumn>
                        <AgGridColumn
                          field="RequestDate"
                          floatingFilter={true}
                          headerName="Request Date"
                          cellRenderer='effectiveDateRenderer'
                          filter="agDateColumnFilter"
                        ></AgGridColumn>
                        <AgGridColumn
                          field="Status"
                          floatingFilter={true}
                          headerName="Status"
                        ></AgGridColumn>
                        <AgGridColumn
                          headerName="Action"
                          sortable={false}
                          cellRenderer={"totalValueRenderer"}
                          type="rightAligned"
                          floatingFilter={false}
                        ></AgGridColumn>
                      </AgGridReact>
                    )}
                    {
                      <PaginationWrapper
                        gridApi={state.gridApi}
                        setPage={onPageSizeChanged}
                      />
                    }
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </>
      {showDeletePopup && (
        <PopupMsgWrapper
          isOpen={showDeletePopup}
          closePopUp={closePopUp}
          confirmPopup={onPopupConfirm}
          message={`Are you sure you want to delete this item?`}
        />
      )}
    </>
  );
};

export default MasterUpdateRequests;
